import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

const REWARD_ICONS = [
  // Backstage
  <svg key="1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 9V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4Z" /><path d="M10 5v14" />
  </svg>,
  // Tickets
  <svg key="2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" /><path d="M13 5v2" /><path d="M13 17v2" /><path d="M13 11v2" />
  </svg>,
  // Meet artists
  <svg key="3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><path d="M12 19v3" />
  </svg>,
  // Insider perks
  <svg key="4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="4" rx="1" /><path d="M12 8v13" /><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" /><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5" />
  </svg>,
];

export default function LpRewards() {
  const headRef = useRevealOnScroll<HTMLDivElement>();
  const r1 = useRevealOnScroll<HTMLDivElement>();
  const r2 = useRevealOnScroll<HTMLDivElement>();
  const r3 = useRevealOnScroll<HTMLDivElement>();
  const r4 = useRevealOnScroll<HTMLDivElement>();
  const tagRef = useRevealOnScroll<HTMLParagraphElement>();
  const refs = [r1, r2, r3, r4];

  const cards = [
    { titleKey: 'landingPage.v2.rewards.card1.title', bodyKey: 'landingPage.v2.rewards.card1.body' },
    { titleKey: 'landingPage.v2.rewards.card2.title', bodyKey: 'landingPage.v2.rewards.card2.body' },
    { titleKey: 'landingPage.v2.rewards.card3.title', bodyKey: 'landingPage.v2.rewards.card3.body' },
    { titleKey: 'landingPage.v2.rewards.card4.title', bodyKey: 'landingPage.v2.rewards.card4.body' },
  ];

  return (
    <section className="rewards section-pad" aria-labelledby="lp-rewards-title">
      <div className="wrap">
        <div ref={headRef} className="sec-head reveal">
          <span className="eyebrow"><span className="dot" />{t('landingPage.v2.rewards.label')}</span>
          <h2 className="display" id="lp-rewards-title">{t('landingPage.v2.rewards.title')}</h2>
          <p className="lead">{t('landingPage.v2.rewards.subtitle')}</p>
        </div>
        <div className="reward-grid">
          {cards.map((card, i) => (
            <div key={i} ref={refs[i]} className="reward reveal">
              <div className="reward__ico">{REWARD_ICONS[i]}</div>
              <div>
                <h4>{t(card.titleKey)}</h4>
                <p>{t(card.bodyKey)}</p>
              </div>
            </div>
          ))}
        </div>
        <p ref={tagRef} className="reward__tag reveal">
          {t('landingPage.v2.rewards.tagPre')} <b>{t('landingPage.v2.rewards.tagAccent')}</b>{t('landingPage.v2.rewards.tagPost')}
        </p>
        <p className="reward__disclaimer">* {t('landingPage.v2.rewards.disclaimer')}</p>
      </div>
    </section>
  );
}
